import { createUniqueId } from 'solid-js'

export function EventRewardIcon() {
  // Minted per instance, so copies of one icon never resolve url(#…) to
  // each other's defs
  const id = createUniqueId()
  const paint0 = `event-reward-icon-${id}-paint0`
  const paint1 = `event-reward-icon-${id}-paint1`
  const clip0 = `event-reward-icon-${id}-clip0`

  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g clip-path={`url(#${clip0})`}>
        <path
          d="M14.5255 39.7968C10.9223 39.7968 7.98391 36.8584 7.98391 33.2552V23.6691C6.98195 22.7539 6.375 21.434 6.375 19.9985V17.5707C6.375 14.8153 8.61014 12.5802 11.3655 12.5802H12.7336C12.8106 11.6842 13.1478 10.8171 13.7163 10.0945L15.5275 7.79196C16.4235 6.65513 17.7626 6 19.2078 6C20.7878 6 22.2329 6.78037 23.1 8.07135C23.9671 6.78037 25.4122 6 26.9922 6C28.4373 6 29.7765 6.65513 30.6725 7.78233L32.4837 10.0849C33.0618 10.8171 33.3893 11.6842 33.4664 12.5802H34.8344C37.5898 12.5802 39.825 14.8153 39.825 17.5707V19.9985C39.825 21.434 39.218 22.7443 38.2161 23.6691V33.2552C38.2161 36.8584 35.2776 39.7968 31.6744 39.7968H14.5255Z"
          fill={`url(#${paint0})`}
        />
        <path
          d="M11.5004 18.7556H34.69V32.7252C34.69 34.6328 33.1389 36.1935 31.2216 36.1935H14.9687C13.0612 36.1935 11.5004 34.6424 11.5004 32.7252V18.7556Z"
          fill={`url(#${paint1})`}
        />
        <path
          d="M26.3564 22.1372H19.8436V36.1839H26.3564V22.1372Z"
          fill="#00B000"
          fill-opacity="0.4"
        />
        <path
          d="M34.2275 15.8557H11.9725C10.8711 15.8557 9.97821 16.7486 9.97821 17.85V20.1526C9.97821 21.254 10.8711 22.1469 11.9725 22.1469H34.2275C35.3289 22.1469 36.2218 21.254 36.2218 20.1526V17.85C36.2218 16.7486 35.3289 15.8557 34.2275 15.8557Z"
          fill="#00AF00"
        />
        <path
          d="M26.3564 15.8557H19.8436V22.1469H26.3564V15.8557Z"
          fill="#3FD200"
          fill-opacity="0.59"
        />
        <path
          d="M28.8998 15.1431L25.9517 15.856H20.2483L17.3002 15.1431C16.0959 14.8541 15.595 13.4186 16.3657 12.4455L18.0806 10.2585C18.8417 9.29512 20.3543 9.43964 20.9227 10.5379L23.1 14.7577L25.2773 10.5379C25.8458 9.43964 27.3583 9.29512 28.1194 10.2585L29.8343 12.4455C30.6051 13.4186 30.1041 14.8541 28.8998 15.1431Z"
          fill="#3BC600"
        />
        <path
          d="M41.255 34.66L41.975 33.94C43.795 32.12 43.795 29.17 41.975 27.36C41.095 26.48 39.925 26 38.685 26C37.445 26 36.275 26.48 35.395 27.36L34.675 28.08L33.955 27.36C33.075 26.48 31.905 26 30.665 26C29.425 26 28.245 26.47 27.365 27.35C25.555 29.17 25.555 32.12 27.365 33.94L28.085 34.66L27.365 35.38C25.545 37.2 25.545 40.15 27.365 41.96C28.245 42.84 29.415 43.32 30.655 43.32C31.895 43.32 33.065 42.84 33.945 41.96L34.665 41.24L35.385 41.96C36.265 42.84 37.435 43.32 38.675 43.32C39.915 43.32 41.085 42.84 41.965 41.96C43.785 40.14 43.785 37.19 41.965 35.38L41.245 34.66H41.255Z"
          fill="white"
        />
        <path
          d="M37.665 34.6601L40.185 32.1401C41.015 31.3101 41.015 29.9701 40.185 29.1501C39.355 28.3301 38.015 28.3201 37.195 29.1501L34.675 31.6701L32.155 29.1501C31.325 28.3201 29.985 28.3201 29.165 29.1501C28.345 29.9801 28.335 31.3201 29.165 32.1401L31.685 34.6601L29.165 37.1801C28.335 38.0101 28.335 39.3501 29.165 40.1701C29.575 40.5801 30.115 40.7901 30.665 40.7901C31.215 40.7901 31.745 40.5801 32.165 40.1701L34.685 37.6501L37.205 40.1701C37.615 40.5801 38.155 40.7901 38.705 40.7901C39.255 40.7901 39.785 40.5801 40.205 40.1701C41.035 39.3401 41.035 38.0001 40.205 37.1801L37.685 34.6601H37.665Z"
          fill="#FF3F6F"
        />
      </g>
      <defs>
        <linearGradient
          id={paint0}
          x1="23.1"
          y1="6"
          x2="23.1"
          y2="39.7968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8FFE01" />
          <stop offset="1" stop-color="#01FE01" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="23.1"
          y1="35.5207"
          x2="23.1"
          y2="20.5877"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#005933" />
          <stop offset="1" stop-color="#008E1A" />
        </linearGradient>
        <clipPath id={clip0}>
          <rect width="46" height="46" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
